var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { action, flow, observable, when } from 'mobx';
import Overlay from '../constructors/overlay.constructor';
import { SHOULD_LOG } from '../env';
import { last } from '../utils/ramdaEquivalents.utils';
import tick from '../utils/wait.utils';
export var makeOverlayController = function () {
    var c = observable({
        UI: null,
        overlays: [],
        present: function (o, options) { return flow(function () {
            var id_1, name_1, existingOverlay, duplicateStrategy, shouldReplace;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(options === null || options === void 0 ? void 0 : options.waitForOtherOverlaysToClose)) return [3 /*break*/, 2];
                        return [4 /*yield*/, when(function () { return c.overlays.length === 0; })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        id_1 = o.id, name_1 = o.name;
                        existingOverlay = c.overlays.find(function (o) { return id_1 ? o.id === id_1 : o.name === name_1; });
                        if (existingOverlay) {
                            duplicateStrategy = o.duplicateStrategy || (o.duplicateStrategyReplaceDeterminer ? 'replace' : undefined);
                            switch (duplicateStrategy) {
                                case 'abort':
                                    SHOULD_LOG() && console.info('Duplicate overlay detected, aborting according to specified strategy.', o);
                                    return [2 /*return*/];
                                case 'throw':
                                    SHOULD_LOG() && console.log(o);
                                    throw Error('Unexpected duplicate overlay detected.');
                                case 'replace':
                                    if (typeof o.duplicateStrategyReplaceDeterminer === 'function') {
                                        shouldReplace = o.duplicateStrategyReplaceDeterminer(existingOverlay.config, o);
                                        if (shouldReplace)
                                            existingOverlay.close();
                                    }
                                    else
                                        existingOverlay.close();
                                    break;
                                case 'continue':
                                default: break;
                            }
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/, new Promise(action(function (resolve, reject) {
                            var _a;
                            var overlay = new Overlay(o, c);
                            c.overlays.push(overlay);
                            var stackEl = document.querySelector('.OverlayStack');
                            (_a = c.UI) === null || _a === void 0 ? void 0 : _a.focusOnElementInPortal(stackEl);
                            resolve(overlay);
                        }))];
                }
            });
        })(); },
        dismiss: function (o) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, flow(function () {
                            var index, overlay;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        index = c.overlays.findIndex(function (overlay) { return typeof o === 'string' ? overlay.config.name === o : overlay === o; });
                                        overlay = c.overlays[index] || last(c.overlays);
                                        if (!overlay)
                                            return [2 /*return*/];
                                        if (!(overlay.status === 'closed')) return [3 /*break*/, 1];
                                        c.overlays.splice(index, 1);
                                        return [3 /*break*/, 3];
                                    case 1: return [4 /*yield*/, overlay.close()];
                                    case 2:
                                        _a.sent();
                                        _a.label = 3;
                                    case 3: return [2 /*return*/];
                                }
                            });
                        })()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); },
        dismissAll: function () { return __awaiter(void 0, void 0, void 0, function () {
            var lastOverlay;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(c.overlays.length > 0)) return [3 /*break*/, 2];
                        lastOverlay = last(c.overlays);
                        c.dismiss(lastOverlay);
                        return [4 /*yield*/, tick()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 0];
                    case 2: return [2 /*return*/];
                }
            });
        }); },
        getOverlay: function (identifier) {
            return c.overlays.find(function (o) { return o.id === identifier || o.name === identifier; });
        },
        hasOverlay: function (query) {
            return Boolean(c.overlays.find(function (o) { return o.id === query || o.name === query; }));
        },
        hasOverlayById: function (overlayId) {
            return Boolean(c.overlays.find(function (o) { return o.id === overlayId; }));
        },
        hasOverlayByName: function (overlayName) {
            return Boolean(c.overlays.find(function (o) { return o.name === overlayName; }));
        },
        get hasOpenedOverlays() {
            return c.overlays.filter(function (o) { return o.status === 'opened'; }).length > 0;
        },
        reset: action(function () {
            c.overlays.forEach(function (o) { return o.close(); });
        })
    });
    return c;
};
